import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { isReleaseGroupScope } from '../../../../../shared/issuesV2';
import * as IssuesV2Store from '../../../../redux/issuesV2';

import ProjectComparisonHeader from './ProjectComparisonHeader';
import ReleaseGroupComparisonHeader from './ReleaseGroupComparisonHeader';

/**
 * ComparisonHeader is a wrapper component that renders the appropriate
 * comparison header based on the current scope (project vs release group).
 */
const ComparisonHeader: VoidFunctionComponent = () => {
  const scope = useSelector(IssuesV2Store.selectors.getScope);

  if (isReleaseGroupScope(scope)) {
    return <ReleaseGroupComparisonHeader />;
  }

  return <ProjectComparisonHeader />;
};

export default ComparisonHeader;
